import { BOOLEAN_OPTIONS } from "@/constant/GeneralOptions/boolean";
import { STATUS } from "@/constant/statusConstants";

const TeamInitialValues = (targetLang, localeCodes, showData = null) => {
  const data = showData?.data;
  return {
    sport_id: data?.sport_id || "",
    team_group_id: data?.team_group_id || "",
    code: data?.code || "",
    // localizations: localeCodes.reduce((acc, localeCode) => {
    //   acc[localeCode] = data?.localization_contents?.[localeCode] ?? "";
    //   return acc;
    // }, {}),
    name: data?.localization_contents?.[targetLang] ?? "",
    icon_url: data?.icon_url || "",
    thumbnail_url: data?.thumbnail_url || "",
    banner_url: data?.banner_url || "",
    is_icon_bordered: data?.is_icon_bordered ?? BOOLEAN_OPTIONS.NO,
    show_in_profile: data?.show_in_profile || BOOLEAN_OPTIONS.NO,
    is_national_team: data?.is_national_team || BOOLEAN_OPTIONS.NO,
    city: data?.city || "",
    country_id: data?.country_id || "",
    foundation_year: data?.foundation_year || "",
    stadium_name: data?.stadium_name || "",
    stadium_capacity: data?.stadium_capacity || "",
    field_width: data?.field_width || "",
    field_length: data?.field_length || "",
    anthem_name: data?.anthem_name || "",
    mascot_1: data?.mascot_1 || "",
    mascot_2: data?.mascot_2 || "",
    rival_team_id_1: data?.rival_team_id_1 || "",
    rival_team_id_2: data?.rival_team_id_2 || "",
    rival_team_id_3: data?.rival_team_id_3 || "",
    hexcode_1: data?.hexcode_1 || "",
    hexcode_2: data?.hexcode_2 || "",
    hexcode_3: data?.hexcode_3 || "",
    hexcode_4: data?.hexcode_4 || "",
    tags: data?.tags || [],
    status: data?.status || STATUS.INACTIVE,
    history_status: data?.history_status || STATUS.INACTIVE,
    auto_translate: data?.auto_translate ?? BOOLEAN_OPTIONS.NO,
    tagline: data?.tagline || "",
    content: data?.content || "",
  };
};

export default TeamInitialValues;
